import { Address } from 'viem';
import { create } from 'zustand';
import { PanelDirection } from '../PanelModal/PanelModal';
import { SettingsPanelId } from './PanelConfig';

interface SettingsState {
  panelStack: SettingsPanelId[];
  direction: PanelDirection;
  pushPanel: (panelId: SettingsPanelId) => void;
  popPanel: () => void;
  resetPanels: () => void;

  // Revoke state
  signerToRevoke: Address | undefined;
  setSignerToRevoke: (signerAddress: Address) => void;
}

export const useSettingsState = create<SettingsState>((set) => ({
  panelStack: [],
  direction: 'right',
  pushPanel: (panelId) =>
    set((state) => ({
      panelStack: [...state.panelStack, panelId],
      direction: 'right',
    })),
  popPanel: () =>
    set((state) => ({
      panelStack: state.panelStack.slice(0, -1),
      direction: 'left',
    })),
  resetPanels: () => set({ panelStack: [], direction: 'right' }),

  signerToRevoke: undefined,
  setSignerToRevoke: (signerAddress: Address) => set({ signerToRevoke: signerAddress }),
}));
